import {combine, createEffect} from 'effector';

import {fetchCustomsList} from 'api/profile/customs';
import {
    createCustomsUser,
    fetchCustomsUsersList,
    removeCustomsUser,
} from 'api/profile/customsUsers';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {CustomsUserRow, CustomsPaginationContent} from 'types/profile';

const domain = rootDomain.createDomain('customsUsersTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchCustomsUsersList,
});

export const fetchCustomsListFx = createEffect({
    name: 'fetchCustomsListFx',
    handler: fetchCustomsList,
});

export const createCustomsUserFx = createEffect({
    name: 'createCustomsUserFx',
    handler: createCustomsUser,
});

export const removeCustomsUserFx = createEffect({
    name: 'removeCustomsUserFx',
    handler: removeCustomsUser,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const onChangeCustomsUserIdForRemoveConfirmation = domain.createEvent<number | null>();

export const data$ = domain.createStore<CustomsPaginationContent<CustomsUserRow> | null>(null);
export const customsUserIdForRemoveConfirmation$ = domain.createStore<number | null>(null);

export const customsList$ = domain.createStore<
    | {
          value: string;
          label: string;
          text: string;
      }[]
    | null
>(null);

export const searchChanged = domain.createEvent<string>();
export const search$ = domain.createStore('').on(searchChanged, (_, value) => value);

export const customsUsersState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    isLoading: fetchDataFx.pending,
});
